import { Box, BoxProps, Center, CenterProps } from '@chakra-ui/react';
import { useUserCache } from 'src/apollo/cache';
import colors from 'src/theme/colors';
import hexToRgb from 'src/utils/hexToRgb';
import fonts from 'src/theme/fonts';
import { useMenuContext } from '../../MenuContext';

function getInitials(firstName?: string | null, lastName?: string | null) {
  const initials = `${firstName?.charAt(0) ?? ''}${lastName?.charAt(0) ?? ''}`.trim().toUpperCase();

  if (initials) {
    return initials;
  }

  return '?';
}

export default function MenuAvatar() {
  const user = useUserCache();
  const [menuState] = useMenuContext();

  return (
    <Box {...(menuState === 'closed' && { cursor: 'pointer' })} {...styles.container}>
      <Center
        w="30px"
        h="30px"
        borderRadius="full"
        background={`linear-gradient(180deg, ${colors.podcastShade100} 22.4%, ${colors.podcastPurple200} 100%)`}
        fontFamily={fonts.bold}
        fontSize="13px"
        color={colors.podcastPurple}
        textShadow="0px 1px 0px rgba(255, 255, 255, 0.35), 0px 1.5px 1px rgba(255, 255, 255, 0.15)"
      >
        {getInitials(user?.firstName ?? undefined, user?.lastName ?? undefined)}
      </Center>
    </Box>
  );
}

const styles: { container: BoxProps; hoverLogoutButton: CenterProps } = {
  container: {
    position: 'relative',
    width: '38px',
    height: '38px',
    border: `4px solid ${colors.white}`,
    borderRadius: '100%',
  },
  hoverLogoutButton: {
    position: 'absolute',
    w: '100%',
    h: '100%',
    bg: hexToRgb(colors.black, 0.5),
    borderRadius: 'full',
  },
};
